import { render, staticRenderFns } from "./McFixedTable.vue?vue&type=template&id=5be9113a&"
import script from "./McFixedTable.vue?vue&type=script&lang=js&"
export * from "./McFixedTable.vue?vue&type=script&lang=js&"
import style0 from "./McFixedTable.vue?vue&type=style&index=0&id=5be9113a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports